export const ORDER_LOADING = 'ORDER_LOADING';
export const ORDERS_FULFILLED = 'ORDERS_FULFILLED';
export const ORDER_FULFILLED = 'ORDER_FULFILLED';
export const ORDER_STATUS_CHANGED = 'ORDER_STATUS_CHANGED';
